import { useMutation } from "@tanstack/react-query";
import { cnlResvApi, cnlResvInfApi } from "components/api/mypage";
import CancelBookView from "components/view/mypage/book/cancel";
import { IOutletContext } from "components/view/mypage/book/layout";
import { IResvInf } from "interface/book";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { alertControl, successControl } from "util/commAction";

export default function BookCancelInfPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { rmPdNo } = useParams();
  const { resvStat, setResvStat } = useOutletContext<IOutletContext>();
  const [cnlResvInf, setCnlResvInf] = useState<IResvInf>();

  //예약취소 상세 조회
  const cnlResvInfMutation = useMutation({
    mutationFn: cnlResvInfApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            const {
              data: { resvInf, cnlFeeAmt, refAmt },
            } = res;
            setCnlResvInf({
              ...resvInf,
              cnlFeeAmt,
              refAmt,
            });
          },
        });
      }
    },
  });

  //선택한 예약 취소
  const cancleMutation = useMutation({
    mutationFn: cnlResvApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            //예약 취소 성공시
            alertControl({
              isOpen: true,
              inner: t("alr_cncl_bk_done_mpg"),
              click: () => {
                //성공시 예약 취소 상세 내역으로 이동
                //mypage/resv/250728000846/cancel
                navigate(pathname.replace("/" + rmPdNo + "/cancel", ""));
                setResvStat("cancel");
              },
            });
          },
        });
      }
    },
  });

  const handleResvCancel = () => {
    //선택한 예약 취소
    if (resvStat === "wait") {
      //취소 상세 페이지로 이동
      setResvStat("cancel");
    }
    if (resvStat === "cancel") {
      //선택한 예약 취소

      alertControl({
        isOpen: true,
        inner: t("alr_cncl_bk_mpg"),
        cncl_btn: true,
        click: () => {
          // 예약 정보 취소
          if (!rmPdNo) {
            return alertControl({
              isOpen: true,
              inner: t("alr_bk_cancel"),
              click: () => {
                navigate(-1);
              },
            });
          }
          if (rmPdNo) {
            cancleMutation.mutate(rmPdNo);
          }
        },
      });
    }
  };

  useEffect(() => {
    if (!!rmPdNo) {
      cnlResvInfMutation.mutate(rmPdNo);
    }
  }, [rmPdNo]);

  return (
    <>
      <CancelBookView
        cnlResvInf={cnlResvInf}
        handleResvCancel={handleResvCancel}
      />
    </>
  );
}
